// **********************************************************
// Product Slider
// **********************************************************

const productSlider = document.querySelectorAll('[data-slider="product-slider"]');

const productSliderOptions = {
  slidesPerView: 3,
  spaceBetween: 8,
  slidesPerGroup: 3,
  speed: 1000,
  watchOverflow: true,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  breakpoints: {
    767: {
      slidesPerView: 4,
      spaceBetween: 40,
      slidesPerGroup: 4,
    },
    1023: {
      slidesPerView: 'auto',
      spaceBetween: 0,
    },
  },
};

productSlider.forEach((el) => {
  const productSliderParent = el.closest('.product-slider');
  const paginationElement = productSliderParent.querySelector('.swiper-pagination');
  productSliderOptions.pagination.el = paginationElement;

  new Swiper(el, productSliderOptions);
});
